import { Box, Card, CardContent, Typography } from "@mui/material";
import NoRoleHeader from "../noRole/noRoleHeader";
import NoAccessIcon from "../../assets/no-role-icon.svg";

const NoAccessPage = () => {
  return (
    <>
      <NoRoleHeader />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="92vh"
        bgcolor="#F9FAFB"
      >
        <Card
          sx={{
            maxWidth: 500,
            p: 4,
            textAlign: "center",
            border: "1.38px solid #E9E9E8",
            borderRadius: 2,
            boxShadow: "none",
          }}
        >
          <CardContent sx={{ gap: 2 }}>
            <Box display="flex" justifyContent="center" mb={2}>
              <img
                src={NoAccessIcon}
                alt="No Access Icon"
                style={{ width: 68, height: 68 }}
              />
            </Box>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: "#0E0D09" }}
              mb={1}
            >
              No Access Assigned
            </Typography>
            <Typography variant="body1" sx={{ color: "#4E4B44" }}>
              Your account does not currently have the required access to use
              this application. Please contact your system administrator for
              assistance.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default NoAccessPage;
